import { getConfig } from '@b2ag/micro-front-tools'
import { createAxiosClientAnonymous, createAxiosClientWithAladinBearer } from '@b2ag/axios'
import { buildCallerId } from '@b2ag/utils/src/caller-id'
import { providePartner } from '@b2ag/partner/src/usePartner'
import { currentAppBrand } from '@b2ag/app-brands'
import { i18n } from '@b2ag/locale'

export function initPartners() {
  const izanamiApiClient = createAxiosClientAnonymous(`${getConfig('FEATURE_FLIPPING_API_HOST')}`)
  const userApiHost = getConfig('USER_API_HOST')
  const partnerApiClient = createAxiosClientWithAladinBearer(`${userApiHost}/v1`, {
    callerId: buildCallerId(),
    i18n,
  })
  providePartner(izanamiApiClient, partnerApiClient, currentAppBrand)
}
